import { render, staticRenderFns } from "./SithMesPrdZpp2List.vue?vue&type=template&id=6e86335a&"
import script from "./SithMesPrdZpp2List.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdZpp2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports